module.exports = __webpack_public_path__ + "img/logo.34d9a47b.svg";